import React from "react";
import useUserStore from "store/zustand/user";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const { token, user, hasHydrated } = useUserStore();
  const location = useLocation();

  if (!hasHydrated) {
    return null;
  }

  // If no token, redirect to fleet login
  if (!token) {
    return <Navigate to="/login-fleet" replace />;
  }

  const isSupplier = user?.is_supplier;

  // If user is a supplier and trying to access root dashboard
  if (isSupplier && location.pathname === "/") {
    return <Navigate to="/supplier-dashboard" replace />;
  }

  // If user is NOT a supplier and trying to access supplier dashboard
  if (!isSupplier && location.pathname === "/supplier-dashboard") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
